import TcSlider from '../services/tc-slider';
export default (sliderWrapper) => {
    const settings = {
        items: 5,
        start: 0,
        gutter: 8,
        showNav: true,
        breakpoints: [
            { items: 4, maxWidth: 1000 },
            { items: 3, maxWidth: 960 },
            { items: 2, maxWidth: 650 },
        ],
    };
    new TcSlider(sliderWrapper, settings);
};
